import { memo } from "react";
import { createPortal } from "react-dom";

export interface ImageLightboxProps {
  imageUrl: string;
  altText: string;
  onClose: () => void;
}

/**
 * A fullscreen lightbox for viewing images.
 * Renders to document.body using a portal.
 */
export const ImageLightbox = memo(function ImageLightbox({
  imageUrl,
  altText,
  onClose,
}: ImageLightboxProps) {
  return createPortal(
    // Note: Using inline styles here because this portal renders to document.body
    // outside the shadow DOM where CSS modules don't apply
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.95)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2_147_483_647,
        cursor: "zoom-out",
      }}
    >
      <button
        onClick={onClose}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = "0.9";
        }}
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          width: "40px",
          height: "40px",
          border: "none",
          backgroundColor: "transparent",
          color: "#fff",
          fontSize: "32px",
          fontWeight: "300",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2_147_483_648,
          padding: 0,
          lineHeight: 1,
          transition: "opacity 0.2s ease",
          opacity: 0.9,
        }}
        type="button"
      >
        ×
      </button>
      <img
        alt={altText}
        onClick={(e) => e.stopPropagation()}
        src={imageUrl}
        style={{
          maxWidth: "95%",
          maxHeight: "95vh",
          objectFit: "contain",
          display: "block",
          pointerEvents: "none",
        }}
      />
    </div>,
    document.body,
  );
});
